
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';

import { Injectable, Inject } from '@angular/core';
import { ServiceBase } from '@app/services/base.service';
import { Cheque } from '@app/models/cheque';
import { ListaChequePesquisaFiltros } from '@app/models/lista-cheque-pesquisa-filtros';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ChequeService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  adicionar(cheque: Cheque): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/lista-cheque', cheque).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterar(cheque: Cheque): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'financeiro/lista-cheque', cheque).pipe(
        catchError((error: any) => observableThrowError(error)));
  }


  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `financeiro/lista-cheque/${id}`);
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `financeiro/lista-cheque/${id}`);
  }

  // se não quebrou pode deletar
  // obterPorTermo() {
  //   return new AutocompleteDataService(this.http, this.URL_API + `financeiro/cheque/ObterAutoComplete`);
  // }

  obterPesquisa(pesquisa: ListaChequePesquisaFiltros): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'financeiro/lista-cheque/pesquisar/', pesquisa, { headers: { meta: ['search'] }});
  }

  compensarCheque(id: number, contaId: number, tipo: string, dataCompensado: string): Observable<any> {
    dataCompensado = encodeURIComponent(dataCompensado);
    tipo = encodeURIComponent(tipo);
    return this.http
      .get<any>(this.URL_API + `financeiro/lista-cheque/compensarCheque/?id=${(id)}&contaId=${(contaId)}&tipo=${(tipo)}&dataCompensado=${(dataCompensado)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }
  descompensarCheque(id: number): Observable<any>{
    return this.http
    .get<any>(this.URL_API + `financeiro/lista-cheque/descompensarCheque/?id=${(id)}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

}
